var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagerIcoFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_66",
    "data-name": "\\uADF8\\uB8F9 66",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.36,
    height: 7.996,
    viewBox: "0 0 7.36 7.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_62",
    "data-name": "\\uADF8\\uB8F9 62",
    transform: "translate(3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_60",
    "data-name": "\\uADF8\\uB8F9 60",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_41",
    "data-name": "\\uD328\\uC2A4 41",
    d: "M0,.562l5.6,0V0L0,0Z",
    transform: "translate(3.962 7.996) rotate(-135)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_42",
    "data-name": "\\uD328\\uC2A4 42",
    d: "M0,.56l5.6,0V0L0,0Z",
    transform: "translate(4.36 0.398) rotate(135)",
    fill: "#aaa"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_63",
    "data-name": "\\uADF8\\uB8F9 63",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_60-2",
    "data-name": "\\uADF8\\uB8F9 60",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_41-2",
    "data-name": "\\uD328\\uC2A4 41",
    d: "M0,.562l5.6,0V0L0,0Z",
    transform: "translate(3.962 7.996) rotate(-135)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_42-2",
    "data-name": "\\uD328\\uC2A4 42",
    d: "M0,.56l5.6,0V0L0,0Z",
    transform: "translate(4.36 0.398) rotate(135)",
    fill: "#aaa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagerIcoFirst);
export default __webpack_public_path__ + "static/media/pager_ico_first.0c1530fcb4ee8e441cb1a55dfee0370b.svg";
export { ForwardRef as ReactComponent };